<template>
  <span>
    <span v-show="isCheck">
      <slot name="onSvg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.673"
          height="15"
          viewBox="0 0 17.673 15"
        >
          <g
            id="グループ_2041"
            data-name="グループ 2041"
            transform="translate(-557 -708)"
          >
            <g
              id="長方形_4111"
              data-name="長方形 4111"
              transform="translate(557 708)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
            >
              <rect width="14" height="15" rx="3" stroke="none" />
              <rect
                x="0.5"
                y="0.5"
                width="13"
                height="14"
                rx="2.5"
                fill="none"
              />
            </g>
            <path
              id="Icon_awesome-check"
              data-name="Icon awesome-check"
              d="M6,17.5.259,11.754a.884.884,0,0,1,0-1.25l1.25-1.25a.884.884,0,0,1,1.25,0l3.869,3.869,8.287-8.287a.884.884,0,0,1,1.25,0l1.25,1.25a.884.884,0,0,1,0,1.25L7.252,17.5A.884.884,0,0,1,6,17.5Z"
              transform="translate(557 703.423)"
              fill="#3acccc"
            />
          </g>
        </svg>
      </slot>
    </span>
    <span v-show="!isCheck">
      <slot name="offSvg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="15"
          viewBox="0 0 14 15"
        >
          <g
            id="長方形_1844"
            data-name="長方形 1844"
            fill="#fff"
            stroke="#707070"
            stroke-width="1"
          >
            <rect width="14" height="15" rx="3" stroke="none" />
            <rect x="0.5" y="0.5" width="13" height="14" rx="2.5" fill="none" />
          </g>
        </svg>
      </slot>
    </span>
  </span>
</template>
<script>
export default {
  props: {
    isCheck: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
